module.exports = "/_next/static/images/StartWithStrategy@2x-e5d21868d14311694884c89fc64707ea.png";